import api from '../../../../App/socket';

export const getUserProfile = _id => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'Read',
        options: {
            limit: 1,
            where: { _id },
            attributes: [
                'login',
                'person.first_name',
                'person.last_name',
                'person.phones._id',
                'person.phones.phone',
                'person.extension_number',
                'person.photos.big',
                'person.maxoptra.driver_id',
                'person.maxoptra.area_of_control_id',
                'divisions',
            ],
            include: [
                {
                    model: 'department',
                    attributes: ['name'],
                },
                {
                    model: 'user_group',
                    attributes: ['name'],
                },
                {
                    model: 'lead_source',
                    path: 'divisions',
                    attributes: ['name'],
                },
                {
                    model: 'user_status',
                    attributes: ['name'],
                },
                {
                    model: 'gender',
                    attributes: ['name'],
                },
                {
                    model: 'prefix_name',
                    attributes: ['name'],
                },
            ],
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_profile_requests/get_user_profile_request.js